import React, { useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  CircularProgress,
  Paper,
  InputAdornment,
} from '@mui/material';
import { Email, Send } from '@mui/icons-material';
import ResetPwdService from '../service/ResetPwdService';

const EmailVerification = ({ onSuccess, resetData }) => {
  const [email, setEmail] = useState(resetData.email || '');
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null);
  const [emailError, setEmailError] = useState('');

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    // Validation en temps réel
    if (value && !validateEmail(value)) {
      setEmailError('Adresse email invalide');
    } else {
      setEmailError('');
    }
  };




  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      setAlert({ severity: 'error', message: 'Veuillez saisir votre adresse email' });
      return;
    }

    if (!validateEmail(email)) {
      setAlert({ severity: 'error', message: 'Veuillez saisir une adresse email valide' });
      return;
    }

    setLoading(true);
    setAlert(null);
    try {
      const payload = email.trim()
      const data = await ResetPwdService.verifyEmail(payload)
      if (data.success) {
        setAlert({
          severity: 'success',
          message: data.message
        });

        // Attendre 2 secondes puis passer à l'étape suivante
        setTimeout(() => {
          onSuccess({
            email: email.trim(),
            sessionId: data.sessionId
          });
        }, 2000);
      } else {
        setAlert({
          severity: 'error',
          message: data.message || 'Erreur lors de la vérification'
        });
      }
    } catch (error) {
      console.error('Erreur:', error);
      setAlert({
        severity: 'error',
        message: 'Erreur de connexion. Veuillez réessayer.'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      {/* En-tête */}
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Typography variant="h5" component="h2" gutterBottom sx={{ color: '#FFF' }}>
          📧 Vérification de l'email
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Étape 1/4 : Saisissez votre adresse email
        </Typography>
      </Box>

      {/* Alerte */}
      {alert && (
        <Alert
          severity={alert.severity}
          sx={{ mb: 3 }}
          onClose={() => setAlert(null)}
        >
          {alert.message}
        </Alert>
      )}

      {/* Formulaire */}
      <Paper
        component="form"
        onSubmit={handleSubmit}
        sx={{
          p: 3,
          backgroundColor: 'grey.50',
          border: '1px solid',
          borderColor: 'grey.200'
        }}
      >
        <TextField
          fullWidth
          label="Adresse email"
          type="email"
          value={email}
          onChange={handleEmailChange}
          placeholder="votre-email@exemple.com"
          disabled={loading}
          error={!!emailError}
          helperText={emailError}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Email color="primary" />
              </InputAdornment>
            ),
          }}
          sx={{ mb: 3 }}
          autoComplete="email"
          autoFocus
        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          size="large"
          disabled={loading || !!emailError || !email.trim()}
          startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <Send />}
          sx={{
            py: 1.5,
            background: '#339669',
            '&:hover': {
              background: '#339669',
            },
          }}
        >
          {loading ? 'Envoi en cours...' : 'Envoyer le code de vérification'}
        </Button>
      </Paper>

      {/* Information */}
      <Box sx={{ textAlign: 'center', mt: 3 }}>
        <Typography variant="body2" color="text.secondary">
          💡 Un code de vérification sera envoyé à votre adresse email
        </Typography>
      </Box>
    </Box>
  );
};

export default EmailVerification;